<div class="input-cell">
    <div class="label-value-input">
        <div class="input-label">Heading</div>
        <div class="input-value">{{section?.sectionData.heading}}</div>
    </div>
    <div class="label-value-input">
        <div class="input-label">
            <nb-icon [ngClass]="isSelected ? 'active': 'inactive'"  class="enabled" icon="navigation-2-outline" pack="eva" title="Select" (click)="selectSection(section?.sectionId)"></nb-icon>
            <!-- <nb-icon icon="edit-outline" pack="eva" (click)="editSection(section?.sectionId)" title="Edit Section"></nb-icon> -->
        </div>
        <div class="input-value upper">{{section?.rendererType}} - {{section?.sectionId}}</div>
    </div>
    <nb-actions class="actions" size="tiny">
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'" icon="edit-outline" pack="eva" (click)="editSection(section?.sectionId)" title="Edit Section"></nb-icon>
            <!-- <nb-icon [ngClass]="isSelected ? 'active': 'inactive'"  class="enabled" icon="navigation-2-outline" pack="eva" title="Select" (click)="selectSection(section?.sectionId)"></nb-icon> -->
        </nb-action>
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'"  icon="grid-outline" pack="eva" title="Edit Cells" (click)="editCells(section?.sectionId)"></nb-icon>
        </nb-action>
        <nb-action>
            <ng-container *ngIf="shown;else show">
                <nb-icon class="enabled" icon="eye-off-outline" pack="eva" title="Hide" (click)="toggleShow(section?.sectionId)"></nb-icon>
            </ng-container>
            <ng-template #show>
                <nb-icon class="enabled"  icon="eye-outline" pack="eva" title="show" (click)="toggleShow(section?.sectionId)"></nb-icon>
            </ng-template>
        </nb-action>
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'" icon="trash-2-outline" pack="eva" title="Delete" (click)="deleteSection(section?.sectionId)"></nb-icon>
        </nb-action>
        
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'"  icon="arrow-circle-up-outline" pack="eva" title="Order Up" (click)="upSection(section?.sectionId)"></nb-icon>
        </nb-action>
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'"  icon="arrow-circle-down-outline" pack="eva" title="Order Down" (click)="downSection(section?.sectionId)"></nb-icon>
        </nb-action>
    </nb-actions>
</div>



